// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Podium_podium__UZwMB {
  list-style: none;
  margin: 0;
  padding: 0;
}

.Podium_place__akeV\\+ {
  flex: 0 1 auto;
  min-width: 0;
  text-align: center;
}

.Podium_avatarWrap__DaHet {
  position: relative;
}

.Podium_avatar__pLqo5 {
  width: 5.5rem;
  height: 5.5rem;
  border-radius: 50%;
  background-color: var(--accent-subtle);
  color: var(--text);
  font-size: 1.25rem;
  font-weight: 700;
}

.Podium_avatarWinner__nLJbq {
  width: 7.5rem;
  height: 7.5rem;
  background-color: var(--accent-medium);
  font-size: 1.75rem;
}

.Podium_medal__oVSe9 {
  position: absolute;
  right: 0;
  bottom: 0.25rem;
  width: 1.75rem;
  height: 1.75rem;
  border-radius: 50%;
  background-color: var(--surface);
  font-size: 0.875rem;
  line-height: 1;
}

.Podium_avatarWinner__nLJbq + .Podium_medal__oVSe9 {
  right: 0.25rem;
  bottom: 0.5rem;
  width: 2rem;
  height: 2rem;
  font-size: 1rem;
}

.Podium_name__8JZhM {
  color: var(--text);
  font-size: 0.9375rem;
  font-weight: 700;
}

.Podium_amount__2W-oH {
  color: var(--text-muted);
  font-size: 0.9375rem;
}

@media (max-width: 359.98px) {
  .Podium_avatar__pLqo5 {
    width: 4.5rem;
    height: 4.5rem;
    font-size: 1.0625rem;
  }

  .Podium_avatarWinner__nLJbq {
    width: 6.25rem;
    height: 6.25rem;
    font-size: 1.5rem;
  }

  .Podium_name__8JZhM,
  .Podium_amount__2W-oH {
    font-size: 0.8125rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Podium/Podium.module.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,sCAAsC;EACtC,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,sCAAsC;EACtC,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,eAAe;EACf,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gCAAgC;EAChC,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,oBAAoB;AACtB;;AAEA;EACE;IACE,aAAa;IACb,cAAc;IACd,oBAAoB;EACtB;;EAEA;IACE,cAAc;IACd,eAAe;IACf,iBAAiB;EACnB;;EAEA;;IAEE,oBAAoB;EACtB;AACF","sourcesContent":[".podium {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n\n.place {\n  flex: 0 1 auto;\n  min-width: 0;\n  text-align: center;\n}\n\n.avatarWrap {\n  position: relative;\n}\n\n.avatar {\n  width: 5.5rem;\n  height: 5.5rem;\n  border-radius: 50%;\n  background-color: var(--accent-subtle);\n  color: var(--text);\n  font-size: 1.25rem;\n  font-weight: 700;\n}\n\n.avatarWinner {\n  width: 7.5rem;\n  height: 7.5rem;\n  background-color: var(--accent-medium);\n  font-size: 1.75rem;\n}\n\n.medal {\n  position: absolute;\n  right: 0;\n  bottom: 0.25rem;\n  width: 1.75rem;\n  height: 1.75rem;\n  border-radius: 50%;\n  background-color: var(--surface);\n  font-size: 0.875rem;\n  line-height: 1;\n}\n\n.avatarWinner + .medal {\n  right: 0.25rem;\n  bottom: 0.5rem;\n  width: 2rem;\n  height: 2rem;\n  font-size: 1rem;\n}\n\n.name {\n  color: var(--text);\n  font-size: 0.9375rem;\n  font-weight: 700;\n}\n\n.amount {\n  color: var(--text-muted);\n  font-size: 0.9375rem;\n}\n\n@media (max-width: 359.98px) {\n  .avatar {\n    width: 4.5rem;\n    height: 4.5rem;\n    font-size: 1.0625rem;\n  }\n\n  .avatarWinner {\n    width: 6.25rem;\n    height: 6.25rem;\n    font-size: 1.5rem;\n  }\n\n  .name,\n  .amount {\n    font-size: 0.8125rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"podium": `Podium_podium__UZwMB`,
	"place": `Podium_place__akeV+`,
	"avatarWrap": `Podium_avatarWrap__DaHet`,
	"avatar": `Podium_avatar__pLqo5`,
	"avatarWinner": `Podium_avatarWinner__nLJbq`,
	"medal": `Podium_medal__oVSe9`,
	"name": `Podium_name__8JZhM`,
	"amount": `Podium_amount__2W-oH`
};
export default ___CSS_LOADER_EXPORT___;
